import { CSSProperties, StrictMode } from 'react';
import { library } from '@fortawesome/fontawesome-svg-core';
import { TourProvider } from '@reactour/tour';
import { createRoot } from 'react-dom/client';
import fontawesomeIcons from 'assets/icons/fontawesome';
import 'rc-tooltip/assets/bootstrap.css';
import 'utils/setup/setupDayjs';
import App from './App';
import './index.module.scss';

import './utils/react-dom-polyfill';
import './utils/setup/reloadOnChunkError';
import './utils/setup/setupGTM';
import './utils/setup/setupSentry';

library.add(...fontawesomeIcons);

const rootElement = document.getElementById('root');

if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <TourProvider
        steps={[]}
        styles={{
          popover: (base) =>
            ({
              ...base,
              '--reactour-accent': '#2a5082',
            }) as CSSProperties,
        }}
      >
        <App />
      </TourProvider>
    </StrictMode>
  );
}
